<template>
  <div class="row align-items-center border-bottom border-bottom-1 border-gray-200 py-10">
    <Select2
        container-class="form-group col-12 col-md-5 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`payslip-pension-`+id"
        :label="$t('payslip.label.title')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('payslip.label.title')"
        :parent-id="parentId && '#'+parentId"
        v-model="pensionData.id"
        :IsInputGroup="$can(abilities.CREATE_PENSION)"
        icon="bi bi-plus"
        :clickAddon="openPensionModal">
      <option v-for="pension in pensions" :value="pension.id" :key="pension.id">
        {{ pension.title }}
      </option>
    </Select2>

    <InputAmount
        containerClass="col-12 col-md-5 mb-7"
        :label="$t('payslip.label.amount')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-solid'"
        :number="pensionData.value"
        :iso="currency"
        :required="true"
        @keyup="handleEdited"
        @amount="(val) => pensionData.value = val"/>

    <div class="col-2">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deletePensionRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </div>
  </div>

  <NewPensionModal :id="'pension-create-modal'+id" @reloadDatatable="reloadPension" :category="pensionType" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";

import NewPensionModal from "@/Modules/RH/views/Setting/pension/components/NewPensionModal.vue";
import {calculatePayslipItemValue} from "@/mixins/Helpers";
import abilities from "@/composables/abilities";
import InputAmount from "@/components/InputAmount.vue";


const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  parentId: String,
  baseSalary: "",
  pensionType: "",
  pension: {
    type: Object,
    default: () => ({
      id: '',
      value: 0,
      edited: false,
    })
  },
  currency: String,
  index: Number,
  id: String,
})


const pensionData = ref(props.pension)

const allPensions = computed(() => store.getters['pensions/getPensions'])

const pensions = computed(() => {
  if(!props.pensionType) return allPensions.value
  return allPensions.value.filter(pension => pension?.category?.value === props.pensionType)
})

const selectedPensionData = computed(() => {
  if(!pensionData.value.id) return null
  return pensions.value.find(al => al.id === pensionData.value.id)
})


watch(() => [props.baseSalary, pensionData.value.id], () => {
  handleChange()
}, { deep: true })

const calcSalaryWithPension = (salary, pension) => {
  if (!salary) return 0
  if(!pension) return 0
  const pensionData = pension?.data.map?.(al => ({
    range_max: parseFloat(al.range_max),
    range_min: parseFloat(al.range_min),
    type: al.type,
    value: parseFloat(al.value)
  }))
  return calculatePayslipItemValue(parseFloat(props.baseSalary), pensionData)
}

const handleChange = () => {
  pensionData.value.edited = false
  pensionData.value.value = calcSalaryWithPension(props.baseSalary, selectedPensionData.value)
}

const handleEdited = () => {
  pensionData.value.edited = true
}

const openPensionModal = () => {
  $('#pension-create-modal'+props.id).modal('toggle')
}

function deletePensionRow(index) {
  emits('deleteRow', index)
}

function reloadPension() {
  store.dispatch('pensions/loadPensions')
}

onMounted(() => {
  handleChange()
})

</script>

<style scoped>
</style>
